import Base from './components/cells/Base';
import ValuePercentage from './components/cells/ValuePercentage/index';

export default function ValuePercentageCell() {}

ValuePercentageCell.prototype.init = function (params) {
    this.eGui = Base(ValuePercentage(params), params);
    return;
};

ValuePercentageCell.prototype.getGui = function () {
    return this.eGui;
};
